import React from 'react';
import { MainTitle } from '../Styled';
import CASES from '../images/cases-all.png';
import SLSITE from '../images/soundlease-side.png';
import APPS from '../images/cases-img.png';
import {
  ServiceKortCon,
  KortTitel,
  PrplServiceKort,
  BluServiceKort,
  RedServiceKort,
  KortUnderTitel,
  Mockup,
  KortLink,
  KortSection,
} from './Services.styled';

const services = () => {
  return (
    <KortSection>
      <MainTitle>Flydende udvikling</MainTitle>
      <ServiceKortCon>
        <KortLink to='Appudvikling'>
          <PrplServiceKort>
            <div>
              <KortTitel>Appudvikling</KortTitel>
              <KortUnderTitel>Lav en App med Noaly</KortUnderTitel>
            </div>
            <Mockup src={APPS} alt="Daniel-Physiques App" />
          </PrplServiceKort>
        </KortLink>
        <KortLink to='Webudvikling'>
          <BluServiceKort>
            <div>
              <KortTitel>Webudvikling</KortTitel>
              <KortUnderTitel>Moderne hjemmesider</KortUnderTitel>
            </div>
            <Mockup src={SLSITE} alt="Soundlease Hjemmeside" />
          </BluServiceKort>
        </KortLink>
        <KortLink to='Cases'>
          <RedServiceKort>
            <div>
              <KortTitel>Cases</KortTitel>
              <KortUnderTitel>Se vores projekter</KortUnderTitel>
            </div>
            <Mockup src={CASES} alt="Vores projekter" />
          </RedServiceKort>
        </KortLink>
      </ServiceKortCon>
    </KortSection>
  );
};

export default services;
